var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStudentsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-students-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e26126",
    d: "M31.302 10.465l-14.954-5.687c-0.212-0.080-0.444-0.080-0.656 0l-14.955 5.687c-0.358 0.137-0.594 0.48-0.594 0.863s0.236 0.726 0.594 0.863l5.77 2.194v6.546c0 2.539 5.020 4.54 9.339 4.567 0.027 0 0.055 0 0.084 0 3.568 0 7.466-1.21 9.097-2.832 0.553-0.55 0.834-1.135 0.834-1.735v-6.546c0-0.041-0.018-0.076-0.023-0.116l3.444-1.31v10.766c0 0.51 0.414 0.923 0.923 0.923s0.923-0.414 0.923-0.923v-11.468l0.176-0.066c0.358-0.137 0.594-0.48 0.594-0.863s-0.238-0.726-0.596-0.863zM24.014 20.933c0 0.036-0.053 0.191-0.29 0.427-1.122 1.118-4.42 2.311-7.867 2.294-4.256-0.026-7.504-1.946-7.504-2.721v-5.846l7.34 2.791c0.106 0.039 0.217 0.060 0.329 0.060s0.223-0.021 0.329-0.060l7.665-2.916v5.97zM16.021 16.028l-12.359-4.7 12.359-4.699 12.357 4.699-12.357 4.7z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudentsActive);
export default __webpack_public_path__ + "static/media/icon-students-active.9fd6a6fc.svg";
export { ForwardRef as ReactComponent };